<ng-diagram-node-resize-adornment>
  <div
    class="group-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-content-id]="node()?.data?.note.id"
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'note'"
    [node]="node()"
  >
    <ng-diagram-port id="port-right" side="right" style="top: 30px" type="source" />

    <div class="group-node__header">
      <mat-icon class="ddc-content-icon">{{ icon() }}</mat-icon>
      <span class="group-node__title">{{ title() }}</span>
    </div>
    <div class="group-node__content">
      <span class="content-title">{{ node()?.data?.note.title }}</span>
    </div>
  </div>
</ng-diagram-node-resize-adornment>
